export const OFFER_UNAVAILABLE_PATH = '/offer-unavailable';
export const OFFER_REFUSED_REASON = 'payment-refused';
/** FIN-8011: lead desviado porque as vendas desta oferta encerraram. */
export const OFFER_CLOSED_REASON = 'closed';
/** FIN-8011 (decisão 14): lead desviado porque as vendas ainda não abriram. */
export const OFFER_NOT_STARTED_REASON = 'not-started';
/** FIN-8011 (decisão 14): /v3/payment recusou com PLAN_SALES_NOT_STARTED. */
export const OFFER_NOT_STARTED_REFUSED_REASON = 'payment-not-started';
/** FIN-8119 (D08): lead desviado porque o produto da oferta esgotou. */
export const OFFER_SOLD_OUT_REASON = 'sold-out';
/** FIN-8119: /v3/payment recusou com PLAN_SOLD_OUT. */
export const OFFER_SOLD_OUT_REFUSED_REASON = 'payment-sold-out';

export const OFFER_UNAVAILABLE_REASONS = [
  OFFER_REFUSED_REASON,
  OFFER_CLOSED_REASON,
  OFFER_NOT_STARTED_REASON,
  OFFER_NOT_STARTED_REFUSED_REASON,
  OFFER_SOLD_OUT_REASON,
  OFFER_SOLD_OUT_REFUSED_REASON,
] as const;

export type OfferUnavailableReason = (typeof OFFER_UNAVAILABLE_REASONS)[number];

/** Lê o `reason` da query; ausente ou desconhecido vira a variação genérica. */
export function parseOfferUnavailableReason(
  value: unknown
): OfferUnavailableReason | undefined {
  return (OFFER_UNAVAILABLE_REASONS as readonly unknown[]).includes(value)
    ? (value as OfferUnavailableReason)
    : undefined;
}

type Query = Record<string, string | string[] | undefined>;

/**
 * Rota da página de obrigado, preservando a query original (oferta, source,
 * seller, utm_*), que mantém o tema do produto num recarregamento.
 */
export function buildOfferUnavailableRoute(
  query: Query,
  reason?: OfferUnavailableReason
): { pathname: string; query: Query } {
  const rest = { ...query };
  delete rest.reason;

  return {
    pathname: OFFER_UNAVAILABLE_PATH,
    query: reason ? { ...rest, reason } : rest,
  };
}
